export function truncateAtWord(text = '', maxChars) {
  const value = String(text).replace(/\s+/g, ' ').trim();
  if (!maxChars || value.length <= maxChars) return value;

  const sliced = value.slice(0, maxChars).trimEnd();
  const lastSpace = sliced.lastIndexOf(' ');
  const cut = lastSpace > 0 ? sliced.slice(0, lastSpace) : sliced;
  return `${cut} …`;
}

export const KC_TRUNCATE = {
  categoryTitle: 42,
  chip: 40,
  oneLine: 52,
  twoLines: 95,
  relatedTitle: 72,
  threeLines: 140,
};
